import { Injectable } from '@angular/core';
import { HelperService } from 'src/app/services';
import { HttpService } from '../http/http.service';
import * as Constant from '../../utils/constant/paths';



@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private helper: HelperService,
    private http:HttpService
  ) { }

  getList(filterData:any) {
    // console.info("notification request data", filterData)
    return this.http.post(Constant.Path.DASHBOARD.GET_NOTIFICATIONS, filterData, null)
  }

  tagAsRead(data:any){
    // console.info("notification tag data", data)
    return this.http.post(Constant.Path.DASHBOARD.POST_READ_NOTIFICATION, data, null)
  }
}
